import { FcsFlag } from "../unleash";

const DEFAULT_HOW_TO_PAY_CONTENTS = {data: []};

export const FlagsWebsite = {
  how_to_pay_contents: new FcsFlag.JSONFlag(DEFAULT_HOW_TO_PAY_CONTENTS),
};

export function initFlagsWebsite() {
  FcsFlag.register("website", FlagsWebsite);
}

export function getHowToPayContents(type) {
  const value = FlagsWebsite.how_to_pay_contents.getValue();
  const contents = Array.isArray(value) ? value : value && value.data;
  if (!Array.isArray(contents) || !type) return [];

  const content = contents.find(item => (
    item && String(item.type || "").toUpperCase() === String(type).toUpperCase()
  ));

  return Array.isArray(content && content.content_list) ? content.content_list : [];
}
